import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { cn } from '../lib/utils';
type Props = {
  children: React.ReactNode;
  className?: string;
  href?: string;
  size?: 'md' | 'lg';
  variant?: 'celeste' | 'gold';
};
export function CTAButton({
  children,
  className = '',
  href = 'https://masterpack-marca-propia-argentina.impultienda.ar/checkout',
  size = 'lg',
  variant = 'celeste'
}: Props) {
  const pad = size === 'lg' ? 'px-8 py-[17px] text-[18px]' : 'px-6 py-[14px] text-base';
  const skin = variant === 'gold' ? 'bg-gold text-ink shadow-[0_10px_40px_-8px_rgba(229,185,75,0.6)] ring-1 ring-gold-soft/60 hover:bg-gold-soft hover:shadow-[0_16px_50px_-8px_rgba(229,185,75,0.8)] focus-visible:ring-white' : 'bg-celeste text-[#04070a] shadow-[0_10px_40px_-8px_rgba(116,172,223,0.7)] ring-1 ring-gold/40 hover:bg-celeste-soft hover:shadow-[0_16px_50px_-8px_rgba(116,172,223,0.9)] focus-visible:ring-gold';
  return <a href={href} className={cn('group inline-flex items-center justify-center gap-2 rounded-xl text-[18px] font-extrabold uppercase tracking-wide transition-all duration-200 hover:-translate-y-0.5 focus:outline-none focus-visible:ring-2', skin, pad, className)} style={{
    paddingTop: "15px",
    paddingBottom: "15px",
    fontSize: "20px",
    paddingLeft: "55px",
    paddingRight: "55px"
  }} data-id="element-49" data-mp="38m5zi8mewcyb">
      {children}
      <ArrowRightIcon className="h-5 w-5 transition-transform duration-200 group-hover:translate-x-1" data-id="element-50" data-mp="1n6l36aka6d6h" />
    </a>;
}